<template lang="pug">
    .wrapper-center-outer
      .wrapper-center-inner
        .aspect-ratio-box
          .aspect-ratio-box-inside.psg-bg
            Video(:hasDevice="hasDevice")
</template>

<script>
import Video from "./Video.vue";
import axios from "axios";
// import bowser from "bowser";

export default {
  name: "tv",
  metaInfo() {
    return {
      title: this.group.name ? `${this.group.name} FanFest Powered By VICI TV` : 'VICI TV'
    };
  },
  data() {
    return {
      organizer: {},
      business: {},
      group: {},
      hasDevice: false
    };
  },
  components: {
    Video
  },
  methods: {
    /* checkClient: function() {
      const browser = bowser.getParser(window.navigator.userAgent);
      
      if(browser.getBrowserName() != 'Chrome' || browser.getPlatformType() != 'desktop')
        this.$router.push({ name: 'client-error' });
    }, */
    configClient: function() {
      var organizerID = this.$route.params.organizer;
      axios
        .get(`${process.env.VUE_APP_CONFIG_ROOT}/${organizerID}/id`)
        .then(response => {
          this.organizer = response.data;
          this.business = response.data.business;
          this.group = response.data.group;
          this.hasDevice = this.organizer.hasDevice;

          this.configSockets(
            this.group.objectId,
            this.business.objectId,
            this.organizer.objectId
          );

          this.logReady();
        })
        .catch(err => Promise.reject(err.message));
    },
    configSockets: function(group, business, organizer) {
      this.$socket.emit("groupRoom", group);
      this.$socket.emit("businessRoom", business);
      this.$socket.emit("organizerRoom", organizer);
    },
    logReady: function() {
      var log = `${this.group.name} // ${
        this.business.name
      } // ${new Date().toUTCString()} (${this.organizer.objectId})`;
      this.$socket.emit("log", log);
      // console.log(log)
    }
  },
  mounted: function() {
    this.configClient();

    setInterval(() => {
      this.logReady();
    }, 60 * 1000 * 10);
  }
};
</script>

<style>
body,
html {
  background-color: black;
  min-height: 100%;
}

.wrapper-center-outer {
  display: table;
  height: 100vh;
  width: 100vw;
}

.wrapper-center-inner {
  display: table-cell;
  vertical-align: middle;
}

.aspect-ratio-box {
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
  background-color: black;
  position: relative;
}
.aspect-ratio-box-inside {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>